<e-list
  header="Groepen"
  filter
  [filtersActive]="activeFilters.isAnyActive"
  search
  [(searchText)]="searchText"
  >
  <ng-container slot="after-header">
    <button
      eBtn
      icon="plus"
      (click)="openCreateDialog()"
      color="primary"
      size="sm"
      >
      Nieuw
    </button>
  </ng-container>
  <ng-container slot="filters">
    <user-groups-filter class="m-2" (filtersChange)="onFilter($event)"></user-groups-filter>
  </ng-container>
  @for (group of filteredGroups | filter: searchText; track group) {
    <e-collapsible-list-item
      [title]="group.name"
      [active]="group.is(activeItem)"
      (click)="ngSelect.emit(group)"
      [opened]="group.is(activeItem)"
      clickable
      actionsOnHover
      >
      <ng-container slot="actions">
        <e-edit-icon-button (click)="openEditDialog(group)"></e-edit-icon-button>
        <e-delete-icon-button (click)="onDelete(group)"></e-delete-icon-button>
      </ng-container>
    </e-collapsible-list-item>
  }
</e-list>

<e-dialog [(open)]="editDialogOpened" title="Groep bewerken">
  <ng-template>
    <formly-metadata-form
      [model]="groupToEdit"
      key="edit"
      (save)="onEditSubmit($event)"
      [loading]="isUpdating"
      (cancel)="editDialogOpened = false"
    ></formly-metadata-form>
  </ng-template>
</e-dialog>

<e-dialog [(open)]="createDialogOpened" title="Nieuwe groep">
  <ng-template>
    <formly-metadata-form
      [model]="newGroup"
      key="create"
      (save)="onCreateSubmit($event)"
      [loading]="isCreating"
      (cancel)="createDialogOpened = false"
    ></formly-metadata-form>
  </ng-template>
</e-dialog>
